module.exports = __webpack_public_path__ + "15fd4361539bd09ca1fe30315fe9dacf.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-real-estate.jpg
// module id = 126
// module chunks = 0